'use strict'
export default class Reports {
    constructor(
        _id_user_owner = '',
        reports=[]
    ) {
        this._id_user_owner = _id_user_owner
        this.reports = reports
    }

}